import React from "react";
import { connect } from "react-redux";
import UserProfileMenu from "components/UserProfileMenu";
import UserProfileDropDown from "components/UserProfileDropDown";

const SmallUserProfile = () => {
  const [openMenu, setOpenMenu] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => setOpenMenu(!openMenu);

  const [openDropDown, setOpenDropDown] = React.useState(false);

  return (
    <div ref={anchorRef}>
      <UserProfileDropDown
        openMenu={openDropDown}
        setOpenMenu={setOpenDropDown}
        menu={
          <UserProfileMenu
            open={openMenu}
            element={anchorRef.current}
            onClose={handleToggle}
            onDropDownClose={() => setOpenDropDown(false)}
          />
        }
      />
    </div>
  );
};

const mapStateToProps = state => ({
  user: state.auth.user,
});

export default connect(mapStateToProps)(SmallUserProfile);
